var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "page-title" }, [
      _vm._v(" " + _vm._s(_vm.$t("data.transactions_summary")) + " "),
    ]),
    _c("div", { staticClass: "page-container" }, [
      _c(
        "div",
        { staticClass: "filter-right-container" },
        [
          _c("span", { staticClass: "transTime" }, [
            _vm._v(_vm._s(_vm.$t("merchantAccount.transaction_date")) + ":"),
          ]),
          _c("el-date-picker", {
            staticClass: "mb-10 picker",
            attrs: {
              format: "yyyy-MM-dd",
              "value-format": "yyyy-MM-dd",
              type: "daterange",
              "range-separator": "~",
              "picker-options": _vm.pickerOptions,
              "start-placeholder": _vm.$t("components.start_date"),
              "end-placeholder": _vm.$t("components.end_date"),
            },
            model: {
              value: _vm.search.times,
              callback: function ($$v) {
                _vm.$set(_vm.search, "times", $$v)
              },
              expression: "search.times",
            },
          }),
          _c(
            "el-button",
            {
              staticClass: "search-btn mb-10",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter },
            },
            [_vm._v(_vm._s(_vm.$t("components.search")))]
          ),
          _c(
            "el-button",
            {
              directives: [
                { name: "trans-download", rawName: "v-trans-download" },
              ],
              staticClass: "mb-10 download-btn",
              attrs: { plain: "", type: "info" },
              on: { click: _vm.onClickDowmloadBtn },
            },
            [
              _c("svg-icon", { attrs: { "icon-class": "download" } }),
              _vm._v(" " + _vm._s(_vm.$t("components.download"))),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "total-container" }, [
        _c("div", { staticClass: "total-item" }, [
          _c("div", { staticClass: "total-item-text" }, [
            _vm._v(" " + _vm._s(_vm.$t("data.collection_amount"))),
          ]),
          _c("div", { staticClass: "color-main-linear-blue total-item-num" }, [
            _vm._v(
              _vm._s(
                _vm._f("toDivideWithDot")(
                  _vm.dateBetweenTransSum.total_payment_amount
                )
              )
            ),
          ]),
        ]),
        _c("div", { staticClass: "total-item" }, [
          _c("div", { staticClass: "total-item-text" }, [
            _vm._v(" " + _vm._s(_vm.$t("data.collection_number"))),
          ]),
          _c("div", { staticClass: "color-main-linear-blue total-item-num" }, [
            _vm._v(_vm._s(_vm.dateBetweenTransSum.total_payment_count || 0)),
          ]),
        ]),
        _c("div", { staticClass: "total-item" }, [
          _c("div", { staticClass: "total-item-text" }, [
            _vm._v(" " + _vm._s(_vm.$t("data.collection_fee"))),
          ]),
          _c("div", { staticClass: "color-main-linear-blue total-item-num" }, [
            _vm._v(
              _vm._s(
                _vm._f("toDivideWithDot")(
                  _vm.dateBetweenTransSum.total_payment_fee_split
                )
              )
            ),
          ]),
        ]),
        _c("div", { staticClass: "total-item" }, [
          _c("div", { staticClass: "total-item-text" }, [
            _vm._v(" " + _vm._s(_vm.$t("data.loan_amount"))),
          ]),
          _c("div", { staticClass: "color-main-linear-blue total-item-num" }, [
            _vm._v(
              _vm._s(
                _vm._f("toDivideWithDot")(
                  _vm.dateBetweenTransSum.total_payout_amount
                )
              )
            ),
          ]),
        ]),
        _c("div", { staticClass: "total-item" }, [
          _c("div", { staticClass: "total-item-text" }, [
            _vm._v(" " + _vm._s(_vm.$t("data.loan_number"))),
          ]),
          _c("div", { staticClass: "color-main-linear-blue total-item-num" }, [
            _vm._v(_vm._s(_vm.dateBetweenTransSum.total_payout_count || 0)),
          ]),
        ]),
        _c("div", { staticClass: "total-item" }, [
          _c("div", { staticClass: "total-item-text" }, [
            _vm._v(" " + _vm._s(_vm.$t("data.loan_fee"))),
          ]),
          _c("div", { staticClass: "color-main-linear-blue total-item-num" }, [
            _vm._v(
              _vm._s(
                _vm._f("toDivideWithDot")(
                  _vm.dateBetweenTransSum.total_payout_fee_split
                )
              )
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "tips" }, [
        _c(
          "span",
          [
            _c("svg-icon", {
              staticStyle: { color: "#488CE8" },
              attrs: { "icon-class": "icon-font-warning" },
            }),
          ],
          1
        ),
        _vm._v(_vm._s(_vm.$t("tips.current_time_zone"))),
      ]),
      _c(
        "div",
        { staticClass: "tableContainer" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                stripe: "",
                fit: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("merchantAccount.transaction_date"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              scope.row.statistic_date
                                ? scope.row.statistic_date.split("00:00:00")[0]
                                : scope.row.statistic_date
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("data.collection_amount"),
                  prop: "payment_amount",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("toDivideWithDot")(
                                scope.row.payment_amount
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("data.collection_number"),
                  prop: "payment_count",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.payment_count))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("data.collection_fee"),
                  prop: "payment_fee_split",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("toDivideWithDot")(
                                scope.row.payment_fee_split
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("data.loan_amount"),
                  prop: "payout_amount",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("toDivideWithDot")(scope.row.payout_amount)
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("data.loan_number"),
                  prop: "payout_count",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.payout_count))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("data.loan_fee"),
                  prop: "payout_fee_split",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("toDivideWithDot")(
                                scope.row.payout_fee_split
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              !_vm.listLoading
                ? _c("paginator", {
                    attrs: { "list-query": _vm.listQuery },
                    on: { "paginator-change": _vm.onClickPaginator },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }